import {TenderStatus} from '@frontend/shared-api';

export const PROVIDER_STATUS_TOOLTIP_KEY_PREFIX = 'selecthorAdmin.projectOverview.providerStatus.';

export const PHASE_PLACEHOLDER = '{phase}';

export const SUBMISSION_DATE_RED_DAYS = 3;
export const SUBMISSION_DATE_ORANGE_DAYS = 5;
export const SUBMISSION_DATE_GREEN_DAYS = 10;

export interface ProviderStatusVM {
  providerName: string;
  status: TenderStatus;
  submissionDate?: Date;
  formattedSubmissionDate: string;
}
